import { render, staticRenderFns } from "./editRateModal.vue?vue&type=template&id=00401a7a&scoped=true&"
import script from "./editRateModal.vue?vue&type=script&lang=js&"
export * from "./editRateModal.vue?vue&type=script&lang=js&"
import style0 from "./editRateModal.vue?vue&type=style&index=0&id=00401a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00401a7a",
  null
  
)

export default component.exports